/*
export enum TICKET_STEP {
  CUSTOMER = 0,
  PRODUCT = 1,
  SYMPTOMS = 2,
  REPAIR_PLAN = 3,
  SCHEDULE = 4,
  REVIEW = 5,
}
*/

import { Validators } from '@angular/forms';


export enum CONTENT_STEP {
  BASIC = 0,
  CUSTOMER = 1,
  PRODUCT = 2,
  SYMPTOMS = 3,
  PRICING = 4,
  SCHEDULE = 5,
}

export default class ContentSteps {
  static STEPS = [{
    label: 'Basic',
    component: 'basic',
    editable: false,
    completed: false,
  }, {
    label: 'Customer',
    component: 'customer',
    editable: false,
    completed: false,
  }, {
    label: 'Product',
    component: 'product',
    editable: false,
    completed: false,
  }, {
    label: 'Symptoms',
    component: 'symptoms',
    editable: false,
    completed: false,
  }, {
    label: 'Repair Plan',
    component: 'pricing',
    editable: false,
    completed: false,
  }, {
    label: 'Schedule',
    component: 'schedule',
    editable: false,
    completed: false,
  }];

  static CONTENT_FORMS: any = {
    basicForm: {
      customerType: [null, Validators.required],
      processType: null,
      serviceType: [null, Validators.required],
      detailDescription: null,
      displayUnitRepairType: null,
      status: null,
      reason: null,
      dealer: [null, Validators.required],
      dealerStore: [null, Validators.required],
    },
    productForm: {
      serialNo: null,
      imei: null,
      modelCode: [{ value: null, disabled: true }],
      demoUnit: null,
      fmr: [{ value: null, disabled: true }],
      fmrName: [{ value: null, disabled: true }],
      purchaseDate: null,
    },
    symptom: {},
    repairPlan: {},
    scheduleForm: {
      scheduleDate: [null, Validators.required],
      scheduleTime: [null, Validators.required],
    }
  };
}
